import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { motion } from "framer-motion";

const LogoutSection = ({ onLogout }) => (
  <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.35 }}>
    <Card className="glass border-red-500/20">
      <CardHeader>
        <CardTitle className="text-lg text-white">Account</CardTitle>
      </CardHeader>
      <CardContent>
        <Button
          onClick={onLogout}
          variant="outline"
          className="w-full border-red-500/30 text-red-400 hover:bg-red-500/10 hover:text-red-300 rounded-full"
          data-testid="logout-btn"
        >
          <LogOut className="w-4 h-4 mr-2" /> Sign Out
        </Button>
      </CardContent>
    </Card>
  </motion.div>
);

export default LogoutSection;
